
<div id="visit-view" class="page-layout blank">
  <div class="content">
    <div class="left">
      <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
        <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
          <div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0'">
            <div>
              <div class="p-10 headercmp overflow-hidden" fxlayout="row" fxlayoutalign="space-between center">
                <div class="float-left pr-16">
                  <h2 class="m-b-0 m-0 actuation-popus"> {{employeeStoreService.employee?.apellidos }}
                    {{employeeStoreService.employee?' , ':''}}
                    {{employeeStoreService.employee?.nombre }}
                    <span class="m-b-15 dateC">Baja por {{leaveTypeInfo}} del <span>{{leaveDate}}</span></span></h2>
                  <app-company-breadcrum></app-company-breadcrum>
                </div>
                <div class="float-right">
                  <button mat-raised-button class="mat-accent m-r-10" (click)="CreateGestionConMutua()">Aceptar</button>
                  <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <form class="example-form" autocomplete="off">
          <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
            <div class="widget" fxFlex="100" fxFlex.gt-sm="25">
              <mat-nav-list class="articles-list mat-nav-list feilds" role="navigation">
                <app-trabajador-view-medico [ActuationOperation]="ActuationOperation" *ngIf="!IsLoading">
                </app-trabajador-view-medico>
              </mat-nav-list>
            </div>
            <div class="widget" fxFlex="100" fxFlex.gt-sm="65" class="actuacion">
              <mat-nav-list class="articles-list mat-nav-list feilds" role="navigation">

                <app-gestion  id="inform-medico-document-card" class="m-b-15" 
                [GestionFormGroup]="GestionFormGroup"
                [LeaveInfo]="leaveInfo">
                </app-gestion>

                <app-document 
                [EmployeeFormGroup]="GestionFormGroup"
                [ActuationOperation]="ActuationOperation">
                </app-document>

              </mat-nav-list>
            </div>
            <div class="widget" fxFlex="100" fxFlex.gt-sm="30">
              <mat-nav-list class="articles-list mat-nav-list feilds" role="navigation">

              </mat-nav-list>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>